/* eslint-disable camelcase */
import React, { memo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConfidenceKRPopup from '../../../components/kr_confidence/confidence-popup.component';
import { updateKRConst } from '../../../constants/updateKR.constants';
import { useTranslation } from 'react-i18next';

type HeaderProps = {
  goal: string,
  name: string,
  target: string,
  showTarget: boolean,
  confidence: any,
  display_kr_confidence: boolean,
  goalId: string,
  metricId: string,
  cascadeId: any,
  stretchTarget: any,
  isStretchEnabled: boolean,
  isRangeKr: boolean,
  lowerLimit: any
}

const MetricDataHeader = ({
    goal, name, target, showTarget, confidence, display_kr_confidence, goalId, metricId, cascadeId, stretchTarget, isStretchEnabled, isRangeKr, lowerLimit
}: HeaderProps): JSX.Element => {
    const { t } =  useTranslation()
    const [showConfidencePopup, setShowConfidencePopup] = useState(false);
    const dispatch = useDispatch();
    const openCloseConfidencePopup = () => {
        setShowConfidencePopup(!showConfidencePopup);
    }
    const headerBtnRef = React.useRef<HTMLInputElement | null>(null);

    const openConfidencePopup = () => {
        setShowConfidencePopup(!showConfidencePopup);
        if (headerBtnRef) headerBtnRef.current.focus();
    }
    const updateMetricConfidence = (data) => {
        dispatch({
            type: updateKRConst.UPDATE_METRIC_CONFIDENCE,
            data
        })
    }

    return (
        <div className="kr-data-header-wrapper">
            <div className="kr-data-header">
                <div className="kr-data-hl">
                    <div className="kr-data-title" role="heading" aria-level={2}>
                        {goal}
                    </div>
                    <div className="kr-data-subtitle">
                        {name}
                    </div>
                </div>
                {
                    !isRangeKr && ((!isStretchEnabled && showTarget) || (isStretchEnabled && showTarget && stretchTarget == null)) && (
                        <div className="kr-data-hr">
                            <div className="kr-data-title" role="heading" aria-level={2}>
                                {t('Target')}
                            </div>
                            <div className="kr-data-subtitle">
                                {target}
                            </div>
                        </div>
                    )
                }
                {
                     (isRangeKr || (isStretchEnabled && showTarget && stretchTarget !== null)) && (
                        <div className="kr-data-hr marginR12" style={{width:'147px'}}>
                            <div className="kr-data-title" role="heading" aria-level={2}>
                            {isRangeKr ? t('Target lower limit') : t('Committed Target')}
                            </div>
                            <div className="kr-data-subtitle">
                                {isRangeKr ? lowerLimit : target}
                            </div>
                        </div>
                    )
                }
                {
                    (isRangeKr || (isStretchEnabled && stretchTarget !== null)) ? (
                        <div className="kr-data-hr marginR12" style={{width:'147px'}}>
                            <div className="kr-data-title" role="heading" aria-level={2}>
                            {isRangeKr ? t('Target upper limit') : t('Stretch Target')}
                            </div>
                            <div className="kr-data-subtitle">
                                {isRangeKr ? target : stretchTarget}
                            </div>
                        </div>
                    ) : ''
                }
                {
                    display_kr_confidence && (
                        <div className="kr-data-hr updateConfidence">
                            {/* eslint-disable  jsx-a11y/label-has-associated-control */}
                            <label htmlFor="confidencePopupButton" className="kr-data-title">
                                {t('Confidence')}
                            </label>
                            <div className="confidenceWrapper">
                                <button
                                    id="confidencePopupButton"
                                    type="button"
                                    aria-label={
                                        `Confidence ${
                                            confidence.confidenceLabel ? confidence.confidenceLabel : t('No Rating')
                                        }`
                                    }
                                    style={{ border: '0' }}
                                    className="update-confidence-wrapper"
                                    onClick={openCloseConfidencePopup}
                                    ref={headerBtnRef}
                                >
                                    <span
                                        className={
                                            `krDetail confidenceIcon confidenceIcon-${
                                                confidence.confidenceLabel && confidence.confidenceLabel != 'No Rating'
                                                    ? confidence.confidenceLabel
                                                    : 'Default'
                                            }
                                            `
                                        }
                                    />
                                    <span className="confidenceIconText">
                                        {confidence.confidenceLabel ? confidence.confidenceLabel : t('No Rating')}
                                    </span>
                                </button>
                                {
                                    showConfidencePopup
              && <ConfidenceKRPopup
                  open={showConfidencePopup}
                  close={openConfidencePopup}
                  confidence={confidence}
                  metricId={metricId}
                  goalId={goalId}
                  cascadeId={cascadeId}
                  fromUpdate
                  updateOkrPop={updateMetricConfidence}
              />
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}
export default memo(MetricDataHeader);
